// @flow

import { Button, LinearProgress } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import CheckRoundedIcon from "@material-ui/icons/CheckRounded";
import Toolbar from "@material-ui/core/Toolbar";
import React from "react";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";

type Props = {
  handleSubmit: Function,
  isSubmitting: boolean,
  isValid: boolean,
  ticketCount: number,
  scrollToError: Function,
};
function TicketReservationFooter({
  handleSubmit,
  isSubmitting,
  ticketCount,
  isValid,
  scrollToError,
}: Props) {
  const classes = useStyles();
  return (
    <>
      <div style={{ height: "calc(100px + env(safe-area-inset-bottom)" }} />
      <AppBar className={classes.appBar} color="inherit">
        <Toolbar className={classes.toolBar}>
          {isSubmitting ? (
            <LinearProgress mb={1} style={{ width: "100%" }} />
          ) : (
            <Grid
              container
              justify="space-between"
              wrap="nowrap"
              alignItems="center"
            >
              <Grid item>
                <Typography variant="subtitle1" component="p">
                  <b>
                    {ticketCount * 3},00 € für {ticketCount}{" "}
                    {ticketCount > 1 ? "Tickets" : "Ticket"}
                  </b>
                </Typography>
                <Grid container>
                  <Grid item>
                    <CheckRoundedIcon color="primary" fontSize="small" />
                  </Grid>
                  <Grid item>
                    <Typography color="textSecondary" variant="caption">
                      einschließlich Steuern
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item>
                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  fullWidth
                  disabled={isSubmitting}
                  onClick={isValid ? handleSubmit : scrollToError}
                  type="submit"
                >
                  {isValid ? "Jetzt buchen" : "Weiter"}
                </Button>
              </Grid>
            </Grid>
          )}
        </Toolbar>
      </AppBar>
    </>
  );
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    appBar: {
      top: "auto",
      bottom: 0,
      paddingTop: 0,
      paddingBottom: "env(safe-area-inset-bottom)",
      borderTopWidth: 1,
      borderBottomWidth: 0,
      borderTopStyle: "solid",
      boxShadow: "0px 0px 23px 0px rgba(0, 0, 0, 0.35)",
    },
    toolBar: {
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
    },
  })
);

export default TicketReservationFooter;
